__turbopack_context__.v({
  "bottomBarContainer": "p9w8DW_bottomBarContainer",
  "bottomBarSlideUp": "p9w8DW_bottomBarSlideUp",
  "buttonWrapper": "p9w8DW_buttonWrapper",
  "currentPrice": "p9w8DW_currentPrice",
  "element": "p9w8DW_element",
  "price": "p9w8DW_price",
  "priceContainer": "p9w8DW_priceContainer",
  "secondary": "p9w8DW_secondary",
  "subtitleTextBtn": "p9w8DW_subtitleTextBtn",
  "totalPriceSingle": "p9w8DW_totalPriceSingle",
});
